import { get, post, put } from './https';

export const GetManageTool = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}) => {
  let url = `/api/v1/admin/tools/list?limit=${limit}&page=${page}`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  if (sortField && sortField !== 'name') {
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    url += `&sortOrder=${sortOrder}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch tool');
  }
};

export const addTool = async ({
  name,
  code,
  description,
  image,
  active,
}: {
  name: string;
  code?: string;
  description: string;
  image: any;
  active?: boolean;
}) => {
  const payload = {
    name,
    code: code || undefined,
    description,
    image,
    active,
  };

  const response = await post('/api/v1/admin/tools/create', payload);

  if (response.status === 201) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to add tool');
  }
};

export const ToggleToolStatus = async (toolId: string): Promise<string> => {
  const response = await get(`/api/v1/admin/tools/active-inactive/${toolId}`);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error(response.statusText || 'Failed to change tool status');
  }
};

export const editTool = async ({
  name,
  code,
  description,
  image,
  active,
  toolId,
}: {
  name: string;
  code?: string;
  description: string;
  image: any;
  active?: boolean;
  toolId: string;
}) => {
  const payload = {
    name,
    code: code || undefined,
    description,
    image,
    active,
    toolId,
  };

  const response = await put('/api/v1/admin/tools/edit', payload);

  if (response.status) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to edit tool');
  }
};
